import { Injectable } from '@angular/core';
import { DataFormatService } from '../services/data-format.service';
import Project from '../interfaces/project';
import ProjectAttribute from '../interfaces/project-attribute';

@Injectable({
  providedIn: 'root',
})
export class CommitteeApprovalDashboardService {
  constructor(private dataFormat: DataFormatService) {}

  public saveDisclosures(committee: any) {}

  public getFundingSource(attributes: ProjectAttribute[] | null | undefined) {
    let warehoused = '-';
    if (!attributes) return warehoused;
    for (let k = 0; k < attributes.length; k++) {
      if (attributes[k]?.attribute?.name === 'Warehoused') {
        warehoused = 'Warehouse';
      }
      if (attributes[k]?.attribute?.name === 'Not Warehoused') {
        warehoused = 'Direct';
      }
    }
    return warehoused;
  }

  public getParticipant(participants: any[], searchRole: string) {
    if (!participants) {
      return { key: '', value: '', link: '' };
    }
    let temp = null;
    for (let k = 0; k < participants.length; k++) {
      let role = participants[k].role.name;
      if (role === searchRole) {
        if (role === 'Developer') {
          role += '/Sponsor';
        }

        let val = '';
        let url = '';
        if (participants[k].organization !== null) {
          if (participants[k].organization.sponsor !== null) {
            val = participants[k].organization.sponsor.name;
            if(participants[k].organization.sponsor.is_repeat){
              val += " (Repeat)";
            }
            url = this.dataFormat.formatLink(
              participants[k].organization.sponsor
            );
          } else {
            val = participants[k].organization.name;
            url = this.dataFormat.formatLink(participants[k].organization);
          }
        } else if(participants[k].sponsor !== null){
          val = participants[k].sponsor.nickname;
          if(participants[k].sponsor.is_repeat){
            val += " (Repeat)";
          }
          url = this.dataFormat.formatLink(participants[k].sponsor,)
        } else {
          val = participants[k].person.name;
          url = this.dataFormat.formatLink(participants[k].person);
        }

        temp = { key: role, value: val, link: url };
        break;
      }
    }
    return temp;
  }
  public getLTEquity(project: Project): number {
    let equity: number = 0;
    if (project.projectCredits) {
      for (let k = 0; k < project.projectCredits.length; k++) {
        if (project.projectCredits[k].equity_amount !== null) {
          equity += project.projectCredits[k].equity_amount;
        }
      }
    }
    return equity;
  }
}
